import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=03b03aa8&scoped=true&"
import script from "./SubmitSuccess.vue?vue&type=script&lang=js&"
export * from "./SubmitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=03b03aa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b03aa8",
  null
  
)

export default component.exports